/**
 * Kolik řádků jmen se vejde do sloupce kiosku na výšku. Výšky jsou MĚŘENÉ (sloupec bez
 * paddingu, řádek včetně spodního okraje), ne konstanty. Když se nevejdou všechny,
 * nechá místo pro řádek „+ N dalších". Nezměřeno (0) = všechny.
 */
export const viditelneRadky = (vyskaSloupce: number, vyskaRadku: number, pocet: number, vyskaDalsich: number): number => {
    if (pocet <= 0) return 0;
    if (vyskaSloupce <= 0 || vyskaRadku <= 0) return pocet;
    if (Math.floor(vyskaSloupce / vyskaRadku) >= pocet) return pocet;
    return Math.max(0, Math.floor((vyskaSloupce - vyskaDalsich) / vyskaRadku));
};
